/**
 * @generated SignedSource<<9781535bcf019c60403f0c560fa2d421>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$data = {
  readonly lastDiscoveredTemplatesGenerationTime?: AGG$DateTime | null | undefined;
  readonly " $fragmentType": "lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar";
};
export type lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$key = {
  readonly " $data"?: lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$data;
  readonly " $fragmentSpreads": FragmentRefs<"lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isDiscoveredTemplatesTimestampEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "lastUpdatedTimestamp_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar",
  "selections": [
    {
      "condition": "isDiscoveredTemplatesTimestampEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lastDiscoveredTemplatesGenerationTime"
        }
      ]
    }
  ],
  "type": "VirtualAgentIntentTemplatesConnection"
};

(node as any).hash = "e7960cb68368107f210dc45906451028";

export default node;
